import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=4ebcd136&scoped=true"
import script from "./Logo.vue?vue&type=script&setup=true&lang=ts"
export * from "./Logo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Logo.vue?vue&type=style&index=0&id=4ebcd136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebcd136",
  null
  
)

export default component.exports